import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import ProductsRoot from "../components/products_root";
import { selectDefaultReducer, selectProducts, selectProductsCount } from "../redux/default/selectors";

const ProductsRootContainer = () => {
  const dispatch = useDispatch();

  const {
    pagesVisible,
    viewMode,
    currentPage,
    productColumns,
    productRows,
    productsPath,
    downloadPaths,
    availableDownloadOptions,
    selectedProductIds,
    blockingUI,
    showLinkToProductPageInProductMenu,
    translations,
  } = useSelector(selectDefaultReducer);

  const productsCount = useSelector(selectProductsCount);
  const allProducts = useSelector(selectProducts);
    
  const products_per_page = productColumns * productRows;
  const pageStartIndex = currentPage * products_per_page - products_per_page;
  const pageEndIndex = currentPage * products_per_page;
  const totalPages = Math.ceil(productsCount / products_per_page);

  const products = allProducts.slice(pageStartIndex, pageEndIndex);
  const moreProductsCount = productsCount - products.length;
  const canLoadMore = products.length < productsCount;

  const onLoadMoreClick = () => dispatch(Action.loadNextPage());
  const onProductPhotoClick = productId => dispatch(Action.productPhotoClicked(productId));
  const onDownloadClick = () => dispatch(Action.downloadRequested());
  const onPageClick = page => dispatch(Action.pageClicked(page));

  return (
    <ProductsRoot
      products={products}
      moreProductsCount={moreProductsCount}
      canLoadMore={canLoadMore}
      viewMode={viewMode}
      currentPage={currentPage}
      productColumns={productColumns}
      totalPages={totalPages}
      productsPath={productsPath}
      downloadPaths={downloadPaths}
      availableDownloadOptions={availableDownloadOptions}
      selectedProductIds={selectedProductIds}
      blockingUI={blockingUI}
      showLinkToProductPageInProductMenu={showLinkToProductPageInProductMenu}
      translations={translations}
      onLoadMoreClick={onLoadMoreClick}
      onProductPhotoClick={onProductPhotoClick}
      onDownloadClick={onDownloadClick}
      onPageClick={onPageClick}
    />
  );
}

export default ProductsRootContainer;